import axios from '@/utils/axios'

export const createSalesTransPrice = (payload ) => {
    return axios.post(`/sales_trans_cost_record`, payload)
}

export const getSalesTransPrice = (payload ) => {
    return axios.get(`/sales_trans_cost_record/`, {
        params: payload
    })
}

export const deleteTransCost = (id) => {
    return axios.delete(`/sales_trans_cost_record/${id}`)
}